import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef
} from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DialogService } from "src/app/Shared/dialog.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { LosService } from "src/app/_LOS/services/los.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { MatTableDataSource } from "@angular/material/table";
declare var $: any;
import * as FileSaver from "file-saver";
const EXCEL_EXTENSION = ".xlsx"
declare class Digio {
  constructor(options: DigioOptions);
  init(): void;
  submit(id1: string, id2: string, id3: string): void;
}

declare const digio: Digio;

interface DigioOptions {
  environment: string;
  Is_redirection_approach: boolean;
  theme: {
    primaryColor: string;
    secondaryColor: string;
    fontUrl: string;
    fontFormat: string;
    fontFamily: string;
  };
}

@Component({
  selector: 'app-quickloan-bank-analysis-view',
  templateUrl: './quickloan-bank-analysis-view.component.html',
  styleUrls: ['./quickloan-bank-analysis-view.component.scss'],
  standalone: false
})
export class QuickloanBankAnalysisViewComponent implements OnInit {
  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  DocName: any = "";
  showSpinner: boolean = false;
  loading: boolean = false;
  currentUser: any;
  Row: any;
  PriviousSixMonth = new Date();
  today: Date = new Date();
  docBaseUrl: any = constantUrl.CrcApplicationDocUrl;
  AllowExtension: any = constantUrl.AllowExtension;
  bankNameFoirCart: any = "other";
  fileNoFoirCart: any;
  productTypeFoirCart: any = "salariedLoan";
  passwordFoirCart: any;
  fileNameAttachment: any;
  dataSourceFoirCart: any;
  CustomerId: any = "";
  DocData: any;
  BankAnalysisData: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  lastUploadedFileName = "";
  CustomerList: any;
  displayedColumns: any[] = [];
  dataSource: any;
  @ViewChild(MatSort) sort: MatSort;
  dataUrl: any;
  docId: any;
  Vendor: any = { VendorName: "" };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  ShowAnalytics_Data: boolean = false;

  tableDateArr: any;
  loanDataForLoop: any;
  accountNumberDrodown: any;
  accountNumber: any = "";
  selectedAccountId: string = "";
  selectedAccountDetails: any = null;
  selectedAccountData: any;
  SelectedCustomer: any;
  MobileList: string[] = [];
  SelectedMobile: string = '';
  MSGType: string = 'Text';   // or WhatsApp
  ReceiveOn: string = '';


  customerPhone: any;
  UnaportDataSource: any;
  isUnaport: boolean = false;
  selectedrow: any;
  unaportproductList: any[] = [];
  SelectedUnaportProductId: any = "";
  //   organizationList: any[] = [];
  // SelectedOrganization: any = null;
  selectedFiles: File[] = [];
  filePasswords: string[] = [];
  ToDate: "";
  statementPeriod: any;
  recencyPeriod: any;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private _Route: Router,
    private dialog: DialogService,
    private dataSharingService: DataSharingService,

    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private _EncrDecrService: EncrDecrService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Bank Analysis");
    console.log("loan Summary", this.loanSummary);
    this.getCustomerList();
    this.fileNoFoirCart = this.loanSummary.ApplicationNo;
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this._MasterService
      .Get_Sms_Configration({ Step_Name: "Bank Analysis Upload" })
      .subscribe((res: any) => {
        if (res && Array.isArray(res) && res.length > 0) {
          this.Vendor = res[0];
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
          if (this.Vendor.VendorName == "Unaport") {
            this.GetUnaportAAProductList();
          }
        } else {
        }
      });
    // this.GetUnaportAAOrganizationDetails();
  }

  getCustomerList() {
    this.LmsService.GetCustomerByLoanNo({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((result) => {
      this.CustomerList = JSON.parse(JSON.stringify(result));
      // this.Product_Category = result[0].Product_Category;
      // this.DealerId = result[0].DealerId;
    });
  }
  GetUnaportAAProductList() {
    this._MasterService
      .GetUnaportAAProductList().subscribe((res: any) => {
        if (res?.data?.length > 0) {
          this.unaportproductList = res.data;
          console.log("Product List:", this.unaportproductList);
        }
      });
  }
  //   GetUnaportAAOrganizationDetails() {
  //   this._MasterService
  //     .GetUnaportorganizationDetails()
  //     .subscribe((res: any) => {

  //       this.organizationList = [];

  //       if (res?.fiutest) {
  //         this.organizationList.push({
  //           label: 'Test',
  //           ...res.fiutest
  //         });
  //       }

  //       if (res?.fiulive) {
  //         this.organizationList.push({
  //           label: 'Live',
  //           ...res.fiulive
  //         });
  //       }

  //       console.log("Org List:", this.organizationList);
  //     });
  // }

  fileChangeListenerFOIR(files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      delete this.DocData;
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      files.value = "";
      delete this.DocData;
      return;
    }

    let $this = this;
    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    this.DocName = _pre + "_" + sanitizedFileName;
    this.lastUploadedFileName = this.DocName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      $this.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }

  removeFileFoir(docFileInput: HTMLInputElement): void {
    this.DocName = "";

    docFileInput.value = "";
  }
  uploadDoc(data: any) {
    this.losService.UploadCrcDoc(data).subscribe((res: any) => {
      if (res == true) {
        var json = {
          password:
            this.passwordFoirCart == undefined ? "" : this.passwordFoirCart,
          bank: this.bankNameFoirCart == undefined ? "" : this.bankNameFoirCart,
          name: this.fileNoFoirCart == undefined ? "" : this.fileNoFoirCart,
          productType:
            this.productTypeFoirCart == undefined
              ? ""
              : this.productTypeFoirCart,
        };
        this._QuickLoanService
          .Save_BankStatementAnalysis({
            LoanId: Number(this.loanSummary.LoanId),
            CustomerId: Number(
              this.CustomerId == undefined ? 0 : this.CustomerId
            ),
            Request: JSON.stringify(json),
            DocName: this.DocName,
            LoginUserId: Number(this.currentUser.userId),
          })
          .subscribe((res: any) => {
            if (res.length > 0) {
              this.QuickLoan_Save_PageProcess("Bank Analysis");
              this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
              this.passwordFoirCart = "";
              (this.CustomerId = ""), (this.DocName = "");
              this.bankNameFoirCart = "other";
              this.productTypeFoirCart = "salariedLoan";
            }
          });
      }
    });
  }
  onNext() {
    this.QuickLoan_Save_PageProcess("Bank Analysis");
    this.action.emit("next");
  }
  QuickLoan_Save_PageProcess(PageType) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: this.PageData.MM_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }
  onSubmitFoirCart() {
    this.uploadDoc({
      ApplicationNo: this.loanSummary.ApplicationNo,
      DocName: this.DocName,
      DocData: this.DocData,
    });
  }
  applyFilter(filterValue: string) {
    this.dataSourceFoirCart.filter = filterValue.trim().toLowerCase();
  }

  getQuickLoan_GetBankStatementAnalysis(id: any, result: any, view: any) {
    if (this.Vendor.VendorName == "CART") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "DocName",
        "View",
        "Delete",
      ];
    }
    if (this.Vendor.VendorName == "DIGIO") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Customer_Mobile",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "ViewStatement",
        "Delete",
      ];
    }
    if (this.Vendor.VendorName == "Unaport") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Customer_Mobile",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "ModifyOn",
        "ViewStatementUnaport",
        "ManualFetechUnaportData"

      ];
    }
    if (this.Vendor.VendorName == "Signzy") {
      this.displayedColumns = [
        "CustomerId",
        "Application_No",
        "Customer_Name",
        "Status",
        "EmployeeName",
        "CreatedOn",
        "DocName",
        "DownloadSignzyAnalysisReport"
      ];
    }
    this._QuickLoanService
      .QuickLoan_GetBankStatementAnalysis({
        LoanId: Number(this.loanSummary.LoanId),
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.BankAnalysisData = JSON.parse(JSON.stringify(res));
          if (id > 0) {
            var find = this.BankAnalysisData.find((x) => x.Id == id);
            if (find) {
              this.docId = find.DocId;
              this.blobToBase64Async(result, this.docId, view);
            }
          }

          this.dataSource = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        } else {
          this.dataSource = null;
        }
      });
    if (this.Vendor.VendorName == "Unaport") {
      this._MasterService
        .QuickLoan_GetBankStatementAnalysisUnaport({
          LoanId: Number(this.loanSummary.LoanId)
        })
        .subscribe((res: any) => {
          console.log("Unaport SDK URL response:", res);
          if (res.length > 0) {
            // this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
            this.dataSource = new MatTableDataSource(res);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        });
    }
    if (this.Vendor.VendorName == "Signzy") {
      this._QuickLoanService
        .QuickLoan_GetBankStatementAnalysis({
          LoanId: Number(this.loanSummary.LoanId),
        }).subscribe((res: any) => {
          if (res.length > 0) {
            this.BankAnalysisData = JSON.parse(JSON.stringify(res));
            this.dataSource = new MatTableDataSource(
              JSON.parse(JSON.stringify(res))
            );
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataSource = null;
          }
        });
    }
  }
  onSearchPendingStatus(row: any) {
    this._QuickLoanService
      .BankAnalysisUpload({
        LoanId: Number(this.loanSummary.LoanId),
        Request: row.Request,
        CustomerId: row.CustomerId,
        LoginUserId: this.currentUser.userId,
        ApplicationNo: row.Application_No,
        Id: row.Id,
        DocName: row.DocName,
        uploaddocUrl: this.docBaseUrl,
      })
      .subscribe((res: any) => {
        this.showSpinner = true;
        if (res.length > 0) {
          this.docId = res[0].MSG;
          this.showSpinner = false;
          this.Row = row;
          this.onDownloadWithoutView();
        }
      });
  }

  onDownloadWithoutView() {
    this.showSpinner = true;
    setTimeout(() => {
      this._QuickLoanService
        .DownloadAnalysisFile({
          DocId: this.docId,
        })
        .subscribe((res: any) => {
          if (res != null) {
            console.log("res", res);
            if (res.size == 0) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Please Try Again!!!",
                ...this.configSuccess,
              });

              this.showSpinner = false;
            } else {
              console.log("res", res);
              this.getQuickLoan_GetBankStatementAnalysis(
                this.Row.Id,
                res,
                false
              );
              // $("#DownloadModel").modal("hide");
              this.Row = null;
              this.docId = 0;
            }
          }
        });
    }, 30000);
  }

  blobToBase64Async(blob: Blob, filename, view): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      let $this = this;
      fileReader.onerror = (e) => reject(fileReader.error);

      fileReader.onload = function () {
        $this.dataUrl = fileReader.result.toString().split(";base64,").pop();
        $this.uploadData(filename + ".xlsx", view);
        return;
      };
      if (blob) {
        fileReader.readAsDataURL(blob);
      }
    });
  }
  uploadData(filename, view) {
    this.losService
      .UploadCrcDoc({
        DocName: filename,
        ApplicationNo: this.loanSummary.ApplicationNo,
        DocData: this.dataUrl,
      })
      .subscribe((res: any) => {
        if (view == true) {
          var url =
            this.docBaseUrl +
            this.loanSummary.ApplicationNo +
            this.Row.DocId +
            ".xlsx";
          window.open(url, "_blank");
        }
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Bank Statement Analysis Upload successfully!!!",
          ...this.configSuccess,
        });

        this.showSpinner = false;
      });
  }
  onDeleteBankStatement(row) {
    const payload: any = {
      Id: Number(row.Id),
      LoginUserId: this.currentUser.userId
    };
    if (this.Vendor?.VendorName === 'DIGIO') {
      payload.DocId = row.DocId;
    }
    this._QuickLoanService
      .QuickLoan_DeleteBankStatementAnalysis(payload)
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.showSpinner = false;
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      });
  }
  onSubmit(response): void {
    const options = {
      environment: "sandbox",
      Is_redirection_approach: true,
      callback: function (res) {
        console.log("Response is: ", res);
        if (res.message != "Success") {
          $("#digio_doc_id").text(res.digio_doc_id);
          $("#RejectClick").click();

        } else {
          $("#RefereshClick").click();
        }
      },
      theme: {
        primaryColor: "#1F002A",
        secondaryColor: "#444444",
        fontUrl: "<font URL>", // replace with actual font URL
        fontFormat: "truetype",
        fontFamily: "NaviBody",
      },
    };

    var digio = new Digio(options);
    digio.init();
    var Ids = response.split(",");
    console.log("Ids", Ids);
    digio.submit(
      Ids[0].toString(), // consent request Id
      Ids[1].toString(), // customer Id
      Ids[2].toString() // gateway token id
    );
  }
  RejectData() {
    var digio_doc_id = $("#digio_doc_id").text();
    this._QuickLoanService
      .QuickLoan_DeleteBankStatementAnalysis({
        Id: 0,
        LoginUserId: this.currentUser.userId,
        DocId: digio_doc_id,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.showSpinner = false;
          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      });
  }
  onSubmitDigioRequest() {
    var _find = this.dataSource?.filteredData.find(
      (x) => x.CustomerId == this.CustomerId && x.Status == "Pending"
    );
    if (_find) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "This customer Already Bank Analysis request Pending.",
        ...this.configSuccess,
      });
    } else {
      const NextFourtyDate = new Date();
      NextFourtyDate.setDate(NextFourtyDate.getDate() + 29);
      NextFourtyDate.setHours(0, 0, 0, 0);

      const CurrentDate = new Date();
      //CurrentDate.setHours(0, 0, 0, 0);
      const yyyy = CurrentDate.getFullYear();
      const mm = String(CurrentDate.getMonth() + 1).padStart(2, '0');
      const dd = String(CurrentDate.getDate()).padStart(2, '0');

      const PriviousSixMonthDate = new Date();

      // this.PriviousSixMonth.setDate(PriviousSixMonthDate.getMonth() - 6);
      // this.PriviousSixMonth.setHours(0, 0, 0, 0);
      this.PriviousSixMonth = new Date(PriviousSixMonthDate.setMonth(PriviousSixMonthDate.getMonth() - 12));

      const endDate =
        NextFourtyDate.toISOString().split("T")[0] + " 00:00:00.000";
      // const startDate =
      //   CurrentDate.toISOString().split("T")[0] + " 00:00:00.000";
      const startDate = `${yyyy}-${mm}-${dd} 00:00:00.000`;
      const PriviousSixMonth =
        PriviousSixMonthDate.toISOString().split("T")[0] + " 00:00:00.000";
      var _findCustomer = this.CustomerList.find(
        (x) => x.CustomerId == this.CustomerId
      );

      if (
        _findCustomer.Customer_Email == undefined ||
        _findCustomer.Customer_Email == null ||
        _findCustomer.Customer_Email == ""
      ) {
        _findCustomer.Customer_Email == "";
      }
      //else {
      var json = {
        customer_details: {
          customer_name: _findCustomer.Customer,
          customer_email: _findCustomer.Customer_Email,
          customer_ref_id: this.loanSummary.ApplicationNo,
          customer_mobile: this.SelectedMobile,
          customer_identifier: this.SelectedMobile
        },
        template_id: "",
        consent_details: {
          consent_start_date: startDate,
          consent_expiry_date: endDate,
          fi_start_date: PriviousSixMonth,
          fi_end_date: endDate,
        },
        customer_message: "Please verify your accounts via Account Aggregator",
        customer_notification_mode: this.getNotificationMode(),
        notify_customer: true

      };
      this._QuickLoanService
        .BankAnalysisRequestDigio({
          LoanId: Number(this.loanSummary.LoanId),
          CustomerId: Number(
            this.CustomerId == undefined ? 0 : this.CustomerId
          ),
          Request: JSON.stringify(json),
          LoginUserId: Number(this.currentUser.userId),
        })
        .subscribe((response: any) => {
          if (response.length > 0) {
            if (response[0].CODE == -1) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "Request Send Customer For  Account Aggregator",
                ...this.configSuccess,
              });
              this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
              //this.onSubmit(response[0].MSG);
            }
            // this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
          }
        });
    }
    // }
  }
  onSearchViewStatement(row) {
    if (
      row.BankStatementDownloadData == null ||
      row.BankStatementDownloadData == undefined ||
      row.BankStatementDownloadData == ""
    ) {
      this._QuickLoanService
        .BankStatementDownloadDigio({ AggregatorId: row.AggregatorId })
        .subscribe((res: any) => {
          if (res.length > 0) {
            if (res[0].CODE == -1) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG,
                ...this.configSuccess,
              });
            } else {
              row.BankStatementDownloadData = res[0].MSG;

              this.tableDateArr = JSON.parse(row.BankStatementDownloadData);

              this.loanDataForLoop = this.tableDateArr?.fi;
              console.log("loanDataForLoop", this.loanDataForLoop);

              this.accountNumberDrodown = this.loanDataForLoop.map((item) => ({
                account_id: item.account_id,
                account_number: item.account_number,
              }));
              console.log("accountNumberDrodown", this.accountNumberDrodown);
              this.onModel();
            }
          } else {
            console.log("Result---", row.BankStatementDownloadData);
          }
        });
    } else {
      // console.log("Result---", row.BankStatementDownloadData);

      this.tableDateArr = JSON.parse(row.BankStatementDownloadData);

      this.loanDataForLoop = this.tableDateArr?.fi;
      console.log("loanDataForLoop", this.loanDataForLoop);

      this.accountNumberDrodown = this.loanDataForLoop.map((item) => ({
        account_id: item.account_id,
        account_number: item.account_number,
      }));
      console.log("accountNumberDrodown", this.accountNumberDrodown);
      this.onModel();
    }
  }

  viewStatement() {
    // console.log("this.selectedAccountId on view click", this.selectedAccountId);
    this.selectedAccountData = this.loanDataForLoop.find(
      (data) => data.account_id == this.selectedAccountId
    );
    this._QuickLoanService
      .QuickLoan_GetLoanAnalytics_Data({ AccountId: this.selectedAccountId })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.ShowAnalytics_Data = true;
        } else {
          this.ShowAnalytics_Data = false;
        }
      });
    console.log("selectedAccountData", this.selectedAccountData);
  }

  onModel() {
    this.ShowAnalytics_Data = false;
    this.selectedAccountData = null;
    this.selectedAccountId = null;

    $("#modalOpen").modal("show");
    $("#modalOpen").css("z-index", "1050");
  }

  onCloseNPAStatementModel() {
    this.selectedAccountData = null;
    this.ShowAnalytics_Data = false;
    this.selectedAccountId = null;
    $("#modalOpen").modal("hide");
  }
  getShowAnalytics_Data() {
    this._QuickLoanService
      .BankAnalyticsDownloadDigio({
        AccountId: this.selectedAccountId,
      })
      .subscribe((response: any) => {
        if (response != null) {
          FileSaver.saveAs(response, this.selectedAccountId + EXCEL_EXTENSION);
        }
      });
  }
  saveAs(blob: Blob, fileName: string) {
    const link = document.createElement("a");
    link.download = fileName;
    link.href = window.URL.createObjectURL(blob);
    link.click();
    window.URL.revokeObjectURL(link.href);
  }
  onCustomerChange(customerId: any) {
    this.SelectedCustomer = this.CustomerList.find(
      c => c.CustomerId == customerId
    );

    this.MobileList = [];
    this.SelectedMobile = '';

    if (this.SelectedCustomer) {
      if (this.SelectedCustomer.Customer_PhoneNo) this.MobileList.push(this.SelectedCustomer.Customer_PhoneNo);
      if (this.SelectedCustomer.Alternate_PhoneNo) this.MobileList.push(this.SelectedCustomer.Alternate_PhoneNo);
      if (this.SelectedCustomer.Customer_WhatsAppNo) this.MobileList.push(this.SelectedCustomer.Customer_WhatsAppNo);
    }
    if (this.MobileList.length === 1) {
      this.SelectedMobile = this.MobileList[0];
    }
  }
  private getNotificationMode(): string {
    switch (this.ReceiveOn) {
      case 'SMS':
        return 'SMS';
      case 'WHATSAPP':
        return 'WHATSAPP';
      case 'BOTH':
        return 'SMS_WHATSAPP';
      default:
        return 'SMS'; // safe fallback
    }
  }
  canDelete(row: any): boolean {
    if (!row || !row.CreatedOn) {
      return false;
    }

    // Optional: only for Pending requests
    if (row.Status !== 'Pending') {
      return false;
    }

    const createdOn = new Date(row.CreatedOn).getTime();
    const now = new Date().getTime();

    const diffInMinutes = (now - createdOn) / (1000 * 60);

    return diffInMinutes > 30;
  }
  InitializeSDK() {
    const phoneNumber = this.getSdkPhoneNumber();

    if (!this.CustomerId) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Select customer before opening Unaport SDK",
        ...this.configSuccess,
      });
      return;
    }

    if (!phoneNumber) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Select a valid mobile number before opening Unaport SDK",
        ...this.configSuccess,
      });
      return;
    }

    this.customerPhone = phoneNumber;
    this.getTokenAndLaunchSDK();
  }

  getTokenAndLaunchSDK() {
    console.log("tetsing: reached sdk component.")
    console.log("CustomerId:", this.CustomerId);
    console.log("customerPhone:", this.customerPhone);

    console.log("Selected Product:", this.SelectedUnaportProductId);

    let fiTypes = [];

    if (this.SelectedUnaportProductId?.consentDetail) {
      const consent = JSON.parse(this.SelectedUnaportProductId.consentDetail);
      fiTypes = consent?.fiTypes || [];
    }

    this._MasterService.GetUnaportUrl({
      customerId: this.CustomerId,
      phoneNumber: this.customerPhone,
      productId: this.SelectedUnaportProductId?.productId,
      ApplicationNo: this.loanSummary.ApplicationNo,
      FIType: fiTypes.join(',')
      // fiuId: this.SelectedOrganization?.entityId || ''

    }).subscribe((res: any) => {

      if (!res?.url) {
        console.error("Token failed");
        return;
      }
      console.log(res);

      this.launchFIUHostedSDK(res);
    });
  }

  launchFIUHostedSDK(encodedurl: any) {

    try {

      // const config = {
      //   theme: {
      //   "background": "#131313",
      //   "accent": "#1B1B1B",
      //   "primary": "#7762FF",
      //   "primaryText": "#FFFFFF",
      //   "primaryButtonText": "131313",
      //   "secondary": "#C589E4",
      //   "secondaryText": "#F2F2F2",
      //   "disabled": "#1F1F1F",
      //   "disabledText": "#FEFEFE",
      //   "border": "#767676",
      //   "hintText": "#9e9e9e",
      //   "errorText": "#d32f2f",
      //   "loaderColor": "#F2F2F2",
      //   "fontName": "Open Sans"
      // },
      //   productId: "07f25803-762d-4e9a-ab3b-b1cb5f2f2f36",
      //   phoneNumber: this.customerPhone,
      //   trackingId: `CID${this.CustomerId}_TS${Date.now()}`,
      //   fiuId: "UNACORES-FIU-UAT",
      //   FIType: "Deposits",
      //   accessToken: tokenData.accessToken,
      //   refreshToken: tokenData.refreshToken,
      //   // redirectUrl: this.currentUrl
      // };

      // const base64Config = btoa(
      //   unescape(encodeURIComponent(JSON.stringify(config)))
      // );

      // const url = `https://sdk.sandbox.unaport.com/view?config=${base64Config}`;
      const URL = encodedurl.url;


      console.log("Final URL:", URL);

      window.open(URL, "_blank");

      this._MasterService.Save_Unaport_AA_API_ReqRes({
        // @LoanId,@CustomerId,@trackingId,@URL,@Request,@LoginUserId,GETDATE()
        LoanId: this.loanSummary.LoanId,
        CustomerId: this.CustomerId,
        trackingId: encodedurl.trackingId,
        URL: `https://sdk.premium.unaport.com/view?config=${this.customerPhone}`,
        Request: JSON.stringify({ URL }),
        LoginUserId: this.currentUser.userId
      }).subscribe((res: any) => {
        console.log("Unaport API log saved:", res);


      })


    } catch (error) {

      console.error("Digio SDK error", error);

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Unable to launch Digio SDK",
        ...this.configSuccess,
      });

    }
    this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
  }
  closeModal() {

    $(`#fiusdk`).modal("hide");
  }
  private getSdkPhoneNumber(): string {
    const mobile = (this.SelectedMobile || this.customerPhone || "").toString().trim();
    return mobile;
  }

  onSearchViewStatementUnaport(row: any) {
    this.selectedrow = row;
    this.isUnaport = true;
    this.Get_Unaport_Analytics_Data_Detail(row);

    if (!row.BankStatementData) {
      // No data available yet
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No data available yet. Please check back after some time.",
        ...this.configSuccess,
      });

    }

    const raw = typeof row.BankStatementData === 'string'
      ? JSON.parse(row.BankStatementData)
      : row.BankStatementData;

    // 🔥 Transform Unaport → Digio format
    this.tableDateArr = this.mapUnaportToFI(raw);
    this.loanDataForLoop = this.tableDateArr?.fi;

    this.accountNumberDrodown = this.loanDataForLoop.map((item: any) => ({
      account_id: item.account_id,
      account_number: item.account_number,
    }));

    this.onModel();
  }
  mapUnaportToFI(apiResponse: any) {
    // const deposit = apiResponse?.data?.DEPOSIT;
    const deposit =
      apiResponse?.data?.DEPOSIT ||
      apiResponse?.data?.DEPOSIT_V2 ||
      apiResponse?.data?.deposit;

    if (!deposit) return { fi: [] };

    const summary = deposit.summary || [];
    const transactions = deposit.transactions || [];
    const holders = deposit.accountHolder || [];

    const fi = summary.map((acc: any) => {

      const accountTxns = transactions
        .filter((txn: any) => txn.accountNumber === acc.accountNumber)
        .map((txn: any) => ({
          txnId: txn.txnId,
          amount: Number(txn.amount),
          type: txn.type,
          narration: txn.narration,
          date: txn.tranTimestamp,
          balance: Number(txn.currentBalance),
          mode: txn.mode,
          reference: txn.reference
        }));

      const holder = holders.find(
        (h: any) => h.accountNumber === acc.accountNumber
      );

      return {
        account_id: acc.accountNumber, // 🔥 acts like Digio account_id
        account_number: acc.accountNumber,
        account_type: acc.accountType,
        current_balance: Number(acc.currentBalance),
        ifsc: acc.ifscCode,
        branch: acc.branch,
        bank: acc.fip,

        holder_name: holder?.name,
        mobile: holder?.mobile,
        pan: holder?.pan,

        transactions: accountTxns
      };
    });

    return { fi };
  }

  FifetchExcelDataBySessionId() {
    // if (!this.selectedAccountData) return;

    this._MasterService
      .FifetchExcelDataBySessionId({
        trackingId: this.selectedrow.trackingId,   // 🔥 important
      })
      .subscribe((response: any) => {

        if (response) {
          FileSaver.saveAs(
            response,
            this.selectedrow.trackingId + '_UNAPORT' + EXCEL_EXTENSION
          );
        }

      });
  }
  async FetchAnalyticsData() {
    const reportIds = this.selectedrow?.reportIdsArray;

    for (const id of reportIds) {
      const res = await this._MasterService
        .FifetchAnalyticsExcelData({ analyticId: id })
        .toPromise();

      if (res) {
        FileSaver.saveAs(
          res,
          `${this.selectedrow.trackingId}_UNAPORT_${id}${EXCEL_EXTENSION}`
        );
      }
    }
  }

  Get_Unaport_Analytics_Data_Detail(row: any) {
    console.log("Fetching analytics data for sessionId:", row.sessionId);

    this._MasterService.Get_Unaport_Analytics_Data_Detail({
      sessionId: row.sessionId
    }).subscribe((res: any) => {

      if (!res) return;
      console.log("Analytics data detail response:", res);

      const reportIds = res[0]?.ReportIds;
      console.log("Extracted ReportIds:", reportIds);

      const reportIdsArray = reportIds
        ? reportIds.split(',').map((x: string) => x.trim())
        : [];

      // ✅ update row
      console.log("Updating row with reportIdsArray:", reportIdsArray);
      row.reportIdsArray = reportIdsArray;

      // 🔥 CRITICAL FIX (you are missing this)
      this.selectedrow = {
        ...this.selectedrow,
        reportIdsArray: reportIdsArray
      };

      console.log("FINAL selectedrow:", this.selectedrow);
    });
  }
  ManualFetechUnaportData(row: any) {
    if (!row.consentId) {
      console.error("No trackingId found for row:", row);
      return;
    }

    this._MasterService
      .UnaportManualfetchAA({
        consentId: row.consentId
      }).subscribe((res: any) => {
        console.log("Unaport ManualfetchAA response:", res);
        if (res?.success) {
          console.log("Fetch triggered:", res.data);

          this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
        }
      });
  }
  onFilesSelected(event: any) {
    const files: FileList = event.target.files;
    this.selectedFiles = Array.from(files);
    this.filePasswords = this.selectedFiles.map(() => ''); // default empty password per file
  }
  removeSelectedFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.filePasswords.splice(index, 1);
  }

  private formatDateForSignzy(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
  UploadSignzyBankStatement() {
    if (!this.selectedFiles?.length) {
      console.error('No files selected');
      return;
    }
    const selectedCustomer = this.CustomerList?.find(
      (c) => c.CustomerId == this.CustomerId
    );

    const formData = new FormData();
    this.selectedFiles.forEach((file) => {
      formData.append('Files', file, file.name);
    });
    this.filePasswords.forEach((pwd) => {
      formData.append('FilePasswords', pwd || '');
    });
    formData.append('CustomerName', selectedCustomer?.Customer || '');
    formData.append('StatementPeriod', this.statementPeriod || '');
    formData.append('RecencyDate', this.formatDateForSignzy(this.ToDate));
    formData.append('RecencyPeriod', this.recencyPeriod || '');
    formData.append('TemplateId', 'template_1');
    formData.append('LoanId', this.loanSummary.LoanId?.toString() || '');
    formData.append('CustomerId', this.CustomerId?.toString() || '');
    formData.append('LoginUserId', this.currentUser.userId?.toString() || '');

    this.showSpinner = true;

    this._MasterService.SignzyBankStatementUpload(formData).subscribe({
      next: (response: any) => {


        // Defense-in-depth: treat a populated `error` as failure even on HTTP 200
        if (response?.error) {
          this.handleUploadError(response.error.message || 'Statement validation failed.');
          this.showSpinner = false;
          return;
        }
        this.selectedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64Data = (reader.result as string).split(',')[1]; // strip "data:application/pdf;base64," prefix
            this.losService
              .UploadCrcDoc({
                DocName: file.name,
                ApplicationNo: this.loanSummary.ApplicationNo,
                DocData: base64Data,
              })
              .subscribe((res: any) => {
                this.showSpinner = false;

                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: 'Bank Statement Analysis Uploaded successfully!!!',
                  ...this.configSuccess,
                });
                this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
              });
          };
          reader.readAsDataURL(file);
        });
        this.recencyPeriod = null;
        this.statementPeriod = null;
        this.ToDate = null;
        this.selectedFiles = [];
        this.filePasswords = [];
        if (this.fileInput?.nativeElement) {
          this.fileInput.nativeElement.value = '';
        }
      },
      error: (err) => {
        this.showSpinner = false;
        const message =
          err?.error?.message || err?.error?.reason || 'Upload failed. Please try again.';
        this.handleUploadError(message);
      },
    });
  }

  private handleUploadError(message: string) {
    console.error('Upload failed:', message);
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      ...this.configSuccess,
    });
  }

  async DownloadSignzyBSAReport(row: any) {
    this._MasterService.SignzyBSADownloadReport({
      reportId: row.DocId,
      templateId: 'template_1',
    }).subscribe(async (res: any) => {
      const result = res?.result;
      if (!result) {
        console.error('No result in response:', res);
        return;
      }

      const downloads: { url: string; filename: string }[] = [];

      if (result.excel) {
        downloads.push({ url: result.excel, filename: `${row.Application_No}_${row.Customer_Name}_BSA_report.xlsx` });
      }
      // if (result.json) {
      //   downloads.push({ url: result.json, filename: `${row.Application_No}_${row.Customer_Name}_BSAreport.json` });
      // }
      (result.accountLevelAnalysis || []).forEach((acc: any) => {
        if (acc.excel) {
          downloads.push({
            url: acc.excel,
            filename: `${row.Application_No}_${row.Customer_Name}_${acc.bankName}_${acc.accountId}.xlsx`,
          });
        }
      });
      // (result.transactionsJsonUrl || []).forEach((txn: any) => {
      //   if (txn.json) {
      //     downloads.push({
      //       url: txn.json,
      //       filename: `${row.Application_No}_${row.Customer_Name}_${txn.bankName}_${txn.accountId}_transactions.json`,
      //     });
      //   }
      // });

      for (const d of downloads) {
        try {
          const blob = await fetch(d.url).then(r => r.blob());
          FileSaver.saveAs(blob, d.filename);
        } catch (err) {
          console.error(`Failed to download ${d.filename}:`, err);
        }
      }
    });
  }

  CheckStatusSignzyReport(row: any) {
    this.showSpinner = true;
    this._MasterService.SignzyBSACheckStatus({
      reportId: row.DocId
    }).subscribe((res: any) => {
      this.showSpinner = false;
      console.log("Checkstatus:", res);
      if (res.report.reportStatus === 'ANALYSED') {
        this.getQuickLoan_GetBankStatementAnalysis(0, null, false);
      }
      else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res.report.reportStatus,
          ...this.configSuccess,
        });
      }
    });
  }
}

